import { render } from "./InvoiceReports.vue?vue&type=template&id=55baa620"
import script from "./InvoiceReports.vue?vue&type=script&lang=js"
export * from "./InvoiceReports.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__